// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"F8-z","paperCutsLineHeight":"G8-z"};